<template>
    <!-- New version -->
    <v-container>
        <v-row>
            <v-col cols="12" class="text-start ma-0 pa-0">
                <span class="font-weight-bold">{{modelValue.index + 1}}</span>. 
                {{ modelValue.title }}
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12" class="ma-0 pa-0" :style="xstyle">
                <v-radio-group
                    :model-value="modelValue.value"
                    @update:model-value="handleChange"                    
                    :name="modelValue.name"
                    :id="modelValue.id"                        
                    :inline="isInline"
                    class="d-flex justify-start"
                >
                    <v-radio
                        v-for="(nr, idx) in numbers"
                        :key="idx"
                        :label="modelValue.labels[idx]"
                        :value="nr"  
                        class="align-start font-weight-thin"                      
                    />
                </v-radio-group>
            </v-col>
        </v-row>
        
        <v-row v-if="modelValue.error">
            <v-col cols="12">
                <div class="text-error">{{ modelValue.error }}</div>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
    name: 'LikertComponent',

    props: ['modelValue',], //modelValue - it the name of the prop that will be used for v-model binding (from parent component)
    emits: ['update:modelValue'],

    data() {
        return {
            numbers: [],
        };
    },

    created() {
        this.generateNumbers();
    },

    computed: {
        isInline() {
        //   return this.$vuetify.display.mdAndUp
          return false;
        },

        xstyle(){
            if(this.modelValue.error) return 'border: 1px solid red'
            return ''
        }
    },

    methods: {
        handleChange(newValue) {
            console.log("Selected value:", newValue);
            this.$emit('update:modelValue', {
                ...this.modelValue,
                value: newValue,
                error: '', // Reset any previous error
            });
        },
        generateNumbers() {
            const [start, end] = this.modelValue.range;
            this.numbers = Array.from({ length: end - start + 1 }, (_, i) => start + i);
        }
    }

}
</script>

<style scoped>
</style>